module.exports = __webpack_public_path__ + "img/ref-1.8d4df292.jpg";